import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "../../assets";
import OrderTile from "./OrderTile";
import { getMyOrders } from "../../actions/myOrders";
import { useInterval } from "../../assets/hooks";

export default function MyOrders() {

	const dispatch = useDispatch();
	const { loading, list } = useSelector(state => state.myOrders);

	useEffect(() => {
		dispatch(getMyOrders());
	}, [dispatch]);

	useInterval(() => {
		dispatch(getMyOrders());
	}, 60000);

	if (loading && !list.length) return <Spinner
		color={"#000000"}
		size={50}
		fullscreen={true}
	/>;

	return <div className="myOrders">

		<section>
			<h4>My orders</h4>
			<div className="inner">
				This is a list of your <b>orderabl</b> orders. Here you can review them and check their statuses.
            </div>
		</section>
		<br /><br />
		<section>
			{list && <div className="inner">
				{list.map(order => <OrderTile
					renderVendor={true}
					key={order.id}
					order={order}
				/>)}
			</div>}
		</section>

	</div>

}
